import { setupLocale } from "../localizationManager";

export var swedishStrings = {
  // "Group By Me"
  groupButton: "Gruppera av mig",
  // "Ungroup By Me"
  ungroupButton: "Avgruppera av mig",
  // "Select Me"
  selectButton: "Välj mig",
  // [Auto-translated] "Column reorder"
  columnReorder: "Kolumnomordning",
  // "Hide column"
  hideColumn: "Göm kolumn",
  // "Show column"
  showColumn: "Visa kolumn",
  // [Auto-translated] "Columns"
  columns: "Kolumner",
  // "Make column private"
  makePrivateColumn: "Gör kolumn privat",
  // "Make column public"
  makePublicColumn: "Gör kolumn offentlig",
  // "Move to Detail"
  moveToDetail: "Flytta till detalj",
  // "Show as Column"
  showAsColumn: "Visa som kolumn",
  // "Search..."
  filterPlaceholder: "Sök...",
  // "Remove rows"
  removeRows: "Ta bort rader",
  // "Show"
  showLabel: "Visa",
  // "entries"
  entriesLabel: "poster",
  // [Auto-translated] "Entries on Page:"
  entriesOnPageLabel: "Inlägg på sidan:",
  // "Texts in table"
  visualizer_text: "Texter i tabell",
  // "Wordcloud"
  visualizer_wordcloud: "Ordmoln",
  // [Auto-translated] "Histogram"
  visualizer_histogram: "Histogram",
  // "Average"
  visualizer_number: "Genomsnitt",
  // [Auto-translated] "Average"
  visualizer_average: "Genomsnitt",
  // "Table"
  visualizer_choices: "Tabell",
  // "Chart"
  visualizer_selectBase: "Diagram",
  // "Chart"
  visualizer_matrix: "Diagram",
  // "Bar"
  chartType_bar: "Stapel",
  // "Vertical Bar"
  chartType_vbar: "Vertikal stapel",
  // "Stacked Bar"
  chartType_stackedbar: "Staplad stapel",
  // "Doughnut"
  chartType_doughnut: "Ring",
  // "Pie"
  chartType_pie: "Cirkel",
  // "Scatter"
  chartType_scatter: "Punkt",
  // "Gauge"
  chartType_gauge: "Mätare",
  // [Auto-translated] "Bullet"
  chartType_bullet: "Bullet",
  // "Line"
  chartType_line: "Linje",
  // [Auto-translated] "Radar"
  chartType_radar: "Radar",
  // [Auto-translated] "Histogram"
  chartType_histogram: "Histogram",
  // [Auto-translated] "Vertical Histogram"
  chartType_vhistogram: "Vertikalt histogram",
  // [Auto-translated] "Stacked Histogram"
  chartType_stackedhistogram: "Staplad histogram",
  // "Hide"
  hideButton: "Göm",
  // "Make private"
  makePrivateButton: "Gör privat",
  // "Make public"
  makePublicButton: "Gör offentlig",
  // "Show"
  showButton: "Visa",
  // [Auto-translated] "Filter"
  filter: "Filter",
  // "Reset Filter"
  resetFilter: "Återställ filter",
  // "Change Locale"
  changeLocale: "Ändra språk",
  // "Clear"
  clearButton: "Rensa",
  // "Choose question to show..."
  addElement: "Välj fråga att visa...",
  // [Auto-translated] "All questions"
  allQuestions: "Alla frågor",
  // [Auto-translated] "Select all"
  selectAll: "Välj alla",
  // [Auto-translated] "Clear selection"
  clearSelection: "Tydligt urval",
  // "Default Order"
  defaultOrder: "Standard ordning",
  // "Ascending"
  ascOrder: "Stigande",
  // "Descending"
  descOrder: "Fallande",
  // "Show minor columns"
  showMinorColumns: "Visa mindre kolumner",
  // "Actions"
  actionsColumn: "Åtgärder",
  // "Other items and comments"
  otherCommentTitle: "Övriga objekt och kommentarer",
  // "Show percentages"
  showPercentages: "Visa procent",
  // "Hide percentages"
  hidePercentages: "Göm procent",
  // [Auto-translated] "Export As..."
  exportAs: "Exportera som...",
  // [Auto-translated] "PDF"
  pdfDownloadCaption: "PDF",
  // [Auto-translated] "Excel"
  xlsxDownloadCaption: "Excel",
  // [Auto-translated] "CSV"
  csvDownloadCaption: "CSV",
  // [Auto-translated] "Export as PDF"
  pdfDownloadHint: "Exportera som PDF",
  // [Auto-translated] "Export as Excel"
  xlsxDownloadHint: "Exportera som Excel",
  // [Auto-translated] "Export as CSV"
  csvDownloadHint: "Exportera som CSV",
  // "Download plot as a PNG file"
  saveDiagramAsPNG: "Ladda ner diagram som PNG-fil",
  // [Auto-translated] "response(s)"
  responsesText: "Svar",
  // [Auto-translated] "No data"
  noData: "Inga data",
  // [Auto-translated] "Select date range..."
  selectDateRange: "Välj datumintervall...",
  // [Auto-translated] "Start date"
  startDate: "Startdatum",
  // [Auto-translated] "End date"
  endDate: "Slutdatum",
  // [Auto-translated] "Include today"
  includeToday: "Inkludera idag",
  // [Auto-translated] "Custom"
  reportingPeriodCustom: "Sedvänja",
  // [Auto-translated] "Last 7 days"
  reportingPeriodLast7days: "Sista 7 dagarna",
  // [Auto-translated] "Last 14 days"
  reportingPeriodLast14days: "De senaste 14 dagarna",
  // [Auto-translated] "Last 28 days"
  reportingPeriodLast28days: "Senaste 28 dagarna",
  // [Auto-translated] "Last 30 days"
  reportingPeriodLast30days: "De senaste 30 dagarna",
  // [Auto-translated] "Last week (starts Monday)"
  reportingPeriodLastWeekMon: "Förra veckan (börjar på måndag)",
  // [Auto-translated] "Last week (starts Sunday)"
  reportingPeriodLastWeekSun: "Förra veckan (börjar på söndag)",
  // [Auto-translated] "Last month"
  reportingPeriodLastMonth: "Förra månaden",
  // [Auto-translated] "Last quarter"
  reportingPeriodLastQuarter: "Sista kvartalet",
  // [Auto-translated] "Last year"
  reportingPeriodLastYear: "Förra året",
  // [Auto-translated] "This week to date (starts Sunday)"
  reportingPeriodWtdSun: "Den här veckan hittills (börjar på söndag)",
  // [Auto-translated] "This week to date (starts Monday)"
  reportingPeriodWtdMon: "Den här veckan hittills (börjar måndag)",
  // [Auto-translated] "This month to date"
  reportingPeriodMtd: "Den här månaden hittills",
  // [Auto-translated] "This quarter to date"
  reportingPeriodQtd: "Detta kvartal hittills",
  // [Auto-translated] "This year to date"
  reportingPeriodYtd: "Hittills i år",
  // "Hide empty answers"
  hideEmptyAnswers: "Göm tomma svar",
  // "Show empty answers"
  showEmptyAnswers: "Visa tomma svar",
  // "All answers"
  "topNValueText-1": "Alla svar",
  // "Top 5 answers"
  topNValueText5: "Topp 5 svar",
  // "Top 10 answers"
  topNValueText10: "Topp 10 svar",
  // "Top 20 answers"
  topNValueText20: "Topp 20 svar",
  // "Hide missing answers"
  hideMissingAnswers: "Göm saknade svar",
  // "Show missing answers"
  showMissingAnswers: "Visa saknade svar",
  // "Missing answers"
  missingAnswersLabel: "Saknade svar",
  // "This question type is not visualized yet"
  noVisualizerForQuestion: "Detta frågetyp är inte visualiserad ännu",
  // "There are no results yet"
  noResults: "Det finns inga resultat ännu",
  // "Per Values"
  showPerValues: "Per värden",
  // "Per Columns"
  showPerColumns: "Per kolumner",
  // "Answer"
  answer: "Svar",
  // "Correct answer: "
  correctAnswer: "Rätt svar: ",
  // "Percentage"
  percentage: "Procent",
  // "Chart"
  statistics_chart: "Diagram",
  // "Responses"
  responses: "Svar",
  // [Auto-translated] "Total responses"
  totalResponses: "Totalt antal svar",
  // [Auto-translated] "NPS"
  visualizer_nps: "NPS",
  // [Auto-translated] "Chart"
  visualizer_boolean: "Diagram",
  // [Auto-translated] "Table"
  visualizer_options: "Bord",
  // [Auto-translated] "NPS"
  npsScore: "NPS",
  // "Promoters"
  npsPromoters: "Promotorer",
  // "Passives"
  npsPassives: "Passiva",
  // "Detractors"
  npsDetractors: "Kritiker",
  // "Category (X Axis):"
  axisXSelectorTitle: "X-axel:",
  // "Legend (Series):"
  axisYSelectorTitle: "Y-axel:",
  // [Auto-translated] "Segments:"
  axisXAlternativeSelectorTitle: "Segment:",
  // [Auto-translated] "Groups:"
  axisYAlternativeSelectorTitle: "Grupper:",
  // [Auto-translated] "Not selected"
  notSelected: "Ej utvald",
  // [Auto-translated] "Secondary Y axis"
  secondYAxisToggleTitle: "Andra Y-axeln",
  // [Auto-translated] "Select a data field..."
  selectDataField: "Välj ett datafält...",
  // [Auto-translated] "Default"
  intervalMode_default: "Standard",
  // [Auto-translated] "Decades"
  intervalMode_decades: "Årtionden",
  // [Auto-translated] "Years"
  intervalMode_years: "År",
  // [Auto-translated] "Quarters"
  intervalMode_quarters: "Bostad",
  // [Auto-translated] "Months"
  intervalMode_months: "Månader",
  // [Auto-translated] "Days"
  intervalMode_days: "Dagar",
  // [Auto-translated] "Auto"
  intervalMode_auto: "Bil",
  // [Auto-translated] "Intervals:"
  intervalModeTitle: "Mellanrum:",
  // [Auto-translated] "Show individual values"
  noRunningTotals: "Visa individuella värden",
  // [Auto-translated] "Show running totals"
  runningTotals: "Visa löpande totaler",
  // [Auto-translated] "Compare periods"
  groupDateSeries: "Jämför perioder",
  // [Auto-translated] "View timeline"
  ungroupDateSeries: "Visa tidslinjen",
  // [Auto-translated] "None"
  noneAggregateText: "Ingen",
  // [Auto-translated] "Aggregate:"
  selectAggregateText: "Aggregat:",
  // [Auto-translated] "Year ends with"
  groupedYearsAxisTitle: "Året slutar med",
  // [Auto-translated] "Series {0}"
  seriesListSeries: "Serie {0}",
  // [Auto-translated] "Values"
  seriesListValuesLabel: "Värderingar",
  // [Auto-translated] "Remove"
  seriesListRemove: "Ta bort",
  // [Auto-translated] "Add Series"
  seriesListAdd: "Lägg till serier",
  // [Auto-translated] "Move to second axis"
  seriesListMoveToSecondAxis: "Flytta till andra axeln",
  // [Auto-translated] "Move to first axis"
  seriesListMoveToFirstAxis: "Flytt till första axeln",
  // [Auto-translated] "Count"
  aggregationCount: "Greve",
  // [Auto-translated] "Sum"
  aggregationSum: "Summa",
  // [Auto-translated] "Average"
  aggregationAverage: "Genomsnitt",
  // [Auto-translated] "Close"
  close: "Stäng",
  // [Auto-translated] "K"
  thousandsSuffix: "K",
  // [Auto-translated] "M"
  millionsSuffix: "M",
  // [Auto-translated] "B"
  billionsSuffix: "Mdr"
};

setupLocale({ localeCode: "sv", strings: swedishStrings, nativeName: "Svenska" });